import { Navigate } from "react-router-dom";

export const PrivateRoute: React.FunctionComponent<any> = ({ children }) => {
  const user = localStorage.getItem("contactId");
  if (!user) {
    return <Navigate to={"/"} />;
  }
  return children;
};
